// @ts-nocheck

import { CancelledSvg, LiveSvg, LostSvg, RunningSvg, WinSvg } from '../assets/svg/history';
import { type BasketItems } from '../states/basket';
import { MyMatchBetStatuses } from '../states/mymatch';
import { type MyMatchBetStatus } from '../states/mymatch';
import theme from '../styled-components/dark';
import { BasketItemStatuses } from '../types/basket';
import { type BasketMode, type BasketStatus } from '../types/basket';
import { type OutcomeStatus, OutcomeStatuses } from '../types/history';
import { MatchViewModes } from '../types/matchView';
import { type MatchViewMode } from '../types/matchView';

export const getOutcomeIconFromStatus = (status: OutcomeStatus) => {
  switch (status) {
    case OutcomeStatuses.WON:
      return WinSvg;
    case OutcomeStatuses.CANCELLED:
      return CancelledSvg;
    case OutcomeStatuses.LIVE:
      return LiveSvg;
    case OutcomeStatuses.RUNNING:
      return RunningSvg;
    case OutcomeStatuses.LOST:
    default:
      return LostSvg;
  }
};

export const getOutcomeColorFromStatus = (status: OutcomeStatus) => {
  switch (status) {
    case OutcomeStatuses.WON:
      return theme.History.betslip.outcome.win.color;
    case OutcomeStatuses.CANCELLED:
      return theme.History.betslip.outcome.cancelled.color;
    case OutcomeStatuses.LIVE:
      return theme.History.betslip.outcome.live.color;
    case OutcomeStatuses.LOST:
      return theme.History.betslip.outcome.lost.color;
    case OutcomeStatuses.RUNNING:
    default:
      return theme.History.betslip.outcome.running.color;
  }
};

export const getIsBasketItemSelected = (
  basketMode: BasketMode,
  basketStatus: BasketStatus,
  isLoading: boolean,
  oddsId: number | string,
  basketItems: BasketItems,
  matchViewMode: MatchViewMode,
  isFromMultichoice?: boolean,
  betMMStatus: MyMatchBetStatus,
  betMultichoiceMMStatus: MyMatchBetStatus,
) => {
  const globalBasketStatus = !isLoading && basketStatus;

  const isStatusValid = (_itemStatus) =>
    _itemStatus !== BasketItemStatuses.VALIDATED &&
    _itemStatus !== BasketItemStatuses.WAITING &&
    globalBasketStatus !== BasketItemStatuses.VALIDATED &&
    globalBasketStatus !== BasketItemStatuses.WAITING;

  if (basketItems[oddsId]) {
    const { status: itemStatus, isFromMultichoice: itemIsFromMultichoice } = basketItems[oddsId];

    return (
      ((matchViewMode === MatchViewModes.MY_MATCH &&
        ((itemIsFromMultichoice && isFromMultichoice) || (!itemIsFromMultichoice && !isFromMultichoice))) ||
        matchViewMode === MatchViewModes.CLASSIC) &&
      isStatusValid(itemStatus)
    );
  }

  const basketItemsAsArray = Object.keys(basketItems).map((itemId) => basketItems[itemId]);

  for (const item of basketItemsAsArray) {
    const { betbuilder: itemIsMyMatch } = item;

    if (itemIsMyMatch) {
      const { selectionItems } = item;

      if (Array.isArray(selectionItems)) {
        for (const selectionItem of selectionItems) {
          const {
            oddId: selectionItemOddId,
            outcomeId: selectionItemOutcomeId,
            outcomeIds: selectionItemOutcomeIds,
            status: selectionItemStatus,
            isFromMultichoice: selectionItemIsFromMultichoice,
          } = selectionItem;

          if (
            Array.isArray(selectionItemOutcomeIds) &&
            isFromMultichoice &&
            (matchViewMode === MatchViewModes.MY_MATCH ||
              (!betMMStatus && betMultichoiceMMStatus === MyMatchBetStatuses.ACTIVE))
          ) {
            for (const multichoiceSelectionItemOutcomeId of selectionItemOutcomeIds) {
              if (multichoiceSelectionItemOutcomeId === oddsId) {
                return isStatusValid(selectionItemStatus);
              }
            }
          } else if (
            (selectionItemIsFromMultichoice && matchViewMode === MatchViewModes.MY_MATCH && isFromMultichoice) ||
            (!Array.isArray(selectionItemOutcomeIds) && !isFromMultichoice && !selectionItemIsFromMultichoice) ||
            matchViewMode === MatchViewModes.CLASSIC
          ) {
            const selectionItemOddsId = selectionItemOddId ?? selectionItemOutcomeId;

            if (selectionItemOddsId === oddsId) {
              return isStatusValid(selectionItemStatus);
            }
          }
        }
      }
    }
  }

  return false;
};
